/** Browser stub for Node `module.createRequire` used by @o3co/ts.hocon include resolution. */
export function createRequire(_url) {
  return (_id) => {
    throw new Error(`Module "${_id}" is not available in the browser.`);
  };
}
